import React from 'react'
import {Button} from 'usg-lib'
import {restUrls} from '../../../../utils/constants'

const GoogleSignInButton = () => {
  const handleClick = () => {
    // Carry ssoTokenAudience / redirectTo across the Google round trip.
    window.location.href = restUrls.googleOidcLoginUrl + window.location.search;
  }

  return (
    <Button variant="primary" onClick={handleClick}>
      Sign in with Google
    </Button>
  )
}

export default GoogleSignInButton
